import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import ProductBacklog from "./pages/ProductBacklog";
import ScrumBoard from "./pages/ScrumBoard";
import TeamManagement from "./pages/TeamManagement";
import Error from "./pages/Error";
import { FirebaseProvider } from "./database/FirebaseContext";

function App() {
	const [colourBlindMode, setcolourBlindMode] = useState(false)
	const onColourBlindMode = () => {
        setcolourBlindMode(true);
    };

    // make the task detail hidden
    const offColourBlindMode = () => {
        setcolourBlindMode(false);
    };

	return (
		<FirebaseProvider>
			<BrowserRouter>
				<Routes>
					<Route index element={<LoginPage />} />
					<Route
						path="/productbacklog"
						element={<ProductBacklog colourBlindMode={colourBlindMode} onColourBlindMode={onColourBlindMode} offColourBlindMode={offColourBlindMode} />}
					/>
					<Route path="/scrumboard" element={<ScrumBoard colourBlindMode={colourBlindMode} onColourBlindMode={onColourBlindMode} offColourBlindMode={offColourBlindMode}/>} />
					<Route
						path="/teammanagement"
						element={<TeamManagement colourBlindMode={colourBlindMode} onColourBlindMode={onColourBlindMode} offColourBlindMode={offColourBlindMode}/>}
					/>
					<Route path="*" element={<Error />} />
				</Routes>
			</BrowserRouter>
		</FirebaseProvider>
	);
}

export default App;
